(function ($, njm) {
    'use strict';

    njm.views.navigationsearch = Backbone.View.extend({

        events: {
        },

        initialize: function () {

            var $this = this;
            $("#insearch").on({
                keyup: function () {
                    $this.getSuggestions();
                },

                click: function () {
                    $this.getSuggestions();
                },

                focus: function () {
                    $this.getSuggestions();
                }

            });

            $('body').click(function (event) {

                if ($(event.target).closest('#searchResult').length != 1 && $(event.target).closest('#insearch').length != 1) {
                    $this.slideUp();
                }
            });

            this.initialiseLiComponents();
        },

        getSuggestions: function () {

            var $this = this,
				search = $('#insearch').val().toLowerCase();

            search = jQuery.trim(search);

            if (search != "" && search.length > 2) {
                $.ajax({
                    url: '/api/search/suggest/GetSuggestions',
                    type: 'get',
                    data: { term: search },
                    dataType: 'json',
                    success: function (response) {

                        var len = response.length;
                        $("#searchResult").empty();
                        for (var i = 0; i < len; i++) {
                            var name = response[i].toLowerCase();
                            $("#searchResult").append("<li value='" + i + "'><a href='#'>" + name.replace(search, '<strong>' + search + '</strong>') + "</a></li>");
                        }
                        //binding click event to li
                        if (len > 0) {
                            $this.initialiseLiComponents();
                            $('#searchResult').show();
                        }
                    },
                    error: function (response) {

                    }
                });
            }
            else {
                $("#searchResult").empty();
            }
        },

        slideUp: function () {
            $('#searchResult').slideUp();
        },

        initialiseLiComponents: function () {
            var $this = this;
            var component = $('#searchResult');
            var focusableEls = component.find('li a');
            var lastFocusableEl = $(focusableEls[focusableEls.length - 1]);

            component.find('li a').on({
                click: function (event) {
                    $this.setText(event);
                }
            });

            lastFocusableEl.keydown(function (event) {
                $this.lastFocusableElTab(event);
            });
        },

        setText: function (event) {
            event.preventDefault();
            var response = $(event.target).closest('a').text();
            $("#insearch").val(response);
            $("#navigationSearch").submit();
            this.slideUp();
        },

        lastFocusableElTab: function (event) {

            var key = event.which;

            if (key === 9) { //tab
                if (!event.shiftKey) {
                    this.slideUp();
                }
            }
        }

    });
})(jQuery, njm);